/* tslint:disable no-any */

let initListener: boolean = false

export const getCryptoPro = (): Promise<any> => {
  return new Promise((resolve) => {
    import('@frontend/crypto-pro').then((module) => {
      if (!initListener) {
        initListener = true
        const listener = (window as TUnknown).attachEvent || window.addEventListener

        listener('message', (event) => {
          if (event.data === 'cadesplugin_load_error') {
            window.cadesplugin_load_error = true
          }
        })

        if (typeof cadesplugin !== 'undefined' && cadesplugin.CreateObjectAsync) {
          cadesplugin.catch(() => {
            window.cadesplugin_load_error = true
          })
        }
      }

      resolve(module.default)
    })
  })
}
